import ko from "knockout";
import ym from "ymaps";
import $ from "jquery";
import './select2.min';
import './select2_locale_ru';
import deliveryDescription from './delivery_description';

function TariffModel()
{
    var self = this;

    self.tariffs = ko.observableArray([]);
    self.tariffsCount = ko.observable(0);
    self.activeTariffType = ko.observable(false);
    self.selectedTariff = ko.observable(null);
    self.activePoint = ko.observable(null);

    /**
     * create ymaps object
     */
    try {
        ym.load('https://api-maps.yandex.ru/2.1/?lang=ru_RU').then(
            () => {
                const ymaps = global.ymaps;
            }
        );
    } catch (error) {
        console.error(error);
    }

    /**
     * @type {null}
     */
    self.address = ko.observable({});
    self.isKladrRegion = ko.observable(false);

    self.listType = ko.observable('map');
    self.togglePointsListType = function (val) {
        if (val === self.listType()) {
            return false;
        }

        self.listType(val);

        if ('map' === val) {
            self.openMap();
        } else {
            self.closeMap();
        }

        return false;
    };

    /**
     * Фильтры для точек тарифов
     */
    self.priceFilters = ko.computed(function() {
        var filters = [
            {
                name: 'pf-lt-1',
                title: 'до 1000 руб.',
                sum: 999,
                forceVisible: true
            },
            {
                name: 'pf-lt-15',
                title: 'от 1000 до 1500 руб.',
                sum: 1400,
                isSpb: true
            },
            {
                name: 'pf-gt-15',
                title: 'от 1500 до 3000 руб.',
                sum: 2500,
                isSpb: true
            },
            {
                name: 'pf-lt-3',
                title: 'от 1000 до 3000 руб.',
                sum: 2500,
                isMsc: true,
                isRegion: true
            },
            {
                name: 'pf-gt-3',
                title: 'от 3000 руб.',
                sum: 3001,
                isMsc: true
            },
            {
                name: 'pf-eq-3',
                title: 'от 3000 до 4000 руб.',
                sum: 3500,
                isRegion: true
            },
            {
                name: 'pf-eq-4',
                title: 'от 4000 до 5000 руб.',
                sum: 4500,
                isRegion: true
            },
            {
                name: 'pf-eq-5',
                title: 'от 5000 до 6000 руб.',
                sum: 5500,
                isRegion: true
            },
            {
                name: 'pf-eq-6',
                title: 'от 6000 до 7000 руб.',
                sum: 6500,
                isRegion: true
            },
            {
                name: 'pf-eq-7',
                title: 'от 7000 до 8000 руб.',
                sum: 7500,
                isRegion: true
            },
            {
                name: 'pf-eq-8',
                title: 'от 8000 до 9000 руб.',
                sum: 8500,
                isRegion: true
            },
            {
                name: 'pf-eq-9',
                title: 'от 9000 до 10000 руб.',
                sum: 9500,
                isRegion: true
            },
            {
                name: 'pf-eq-10',
                title: 'от 10000 руб.',
                sum: 10001,
                isRegion: true
            }
        ];

        return filters.filter(function(v) {
            if (v.forceVisible) {
                return true;
            }

            if (self.address().kladr) {
                let isSpb = String(self.address().kladr).match(/^78/);
                let isMsc = String(self.address().kladr).match(/^(50|77)/);
                if (isSpb) {
                    if ('pf-lt-3' === v.name) {
                        return false;
                    }
                    return (v.isSpb || v.isRegion);
                }
                if (isMsc) {
                    return v.isMsc;
                }
            }

            if (self.isKladrRegion()) {
                return v.isRegion;
            }

            return !v.isRegion;
        });
    }, this);

    /**
     *
     */
    self.activeTariffFilters = ko.observableArray(['pf-gt-3']);
    self.toggleTariffFilter = function (name) {
        if (typeof name === 'object') {
            name = name.name;
        }

        if (name.match(/^pf-/)) {
            if (-1 != self.activeTariffFilters.indexOf(name)) {
                return false;
            }

            self.activeTariffFilters.remove(
                function (i) {
                    return (!i.match(/^pf-/)) ? false : name !== i;
                }
            );
            self.activeTariffFilters.push(name);

            if (self.address().kladr || self.address().cityName) {
                self.getTariffsFromService(self.address());
            }

            if (true === self.isMapOpened) {
                self.addPointsToMap();
            }

            return false;
        }

        if (-1 != self.activeTariffFilters.indexOf(name)) {
            self.activeTariffFilters.remove(name);
        } else {
            self.activeTariffFilters.push(name);
        }

        if (true === self.isMapOpened) {
            self.addPointsToMap();
        }

        return false;
    };

    /**
     * Сортировка точек тарифов
     */
    self.activeTariffSort = ko.observable('address');
    self.toggleTariffSort = function (val) {
        self.activeTariffSort(val);
        return false;
    };

    /**
     * Filtered Tariffs
     */
    self.filteredPoints = ko.computed(
        function () {
            if (!self.activeTariffType() || 'TODOOR' === self.activeTariffType()) {
                return [];
            }

            var trf = self.getTariffsMapByType(self.activeTariffType());
            var res = trf.points;
            self.activeTariffFilters();
            self.activeTariffSort();

            if (self.activeTariffFilters().length > 0) {
                res = ko.utils.arrayFilter(
                    res, function (item) {
                        if (-1 != self.activeTariffFilters.indexOf('wo-prepay')) {
                            if (false === self.isCashAvailable(trf, item)) {
                                return false;
                            }
                        }

                        if (-1 != self.activeTariffFilters.indexOf('wo-weekend')) {
                            if (item.schedules && item.schedules.length > 0) {
                                if (item.schedules.length < 7) {
                                    return false;
                                }
                            }
                        }

                        if (-1 != self.activeTariffFilters.indexOf('wo-limits')) {
                            if (item.serverData.limits) {
                                return false;
                            }
                        }

                        if (-1 != self.activeTariffFilters.indexOf('radius5')) {
                            if (item.distance && (parseFloat(item.distance) > 5)) {
                                return false;
                            }
                        }

                        if (-1 != self.activeTariffFilters.indexOf('wo-cash')) {
                            if (item.hasPaymentCard !== 1) {
                                return false;
                            }
                        }

                        return true;
                    }
                );
            }

            if ('PICKUP' === trf.key || 'POST' === trf.key) {
                res.sort(
                    function (left, right) {
                        if ('distance' === self.activeTariffSort()) {
                            var a1 = parseFloat(left.distance), b1 = parseFloat(right.distance);
                            return (a1 < b1) ? -1 : (a1 > b1 ? 1 : 0);
                        } else if ('address' === self.activeTariffSort()) {
                            var a1 = left.address, b1 = right.address;
                            return (a1 < b1) ? -1 : (a1 > b1 ? 1 : 0);
                        } else if ('cost' === self.activeTariffSort()) {
                            var a1 = left.parent.cost, b1 = right.parent.cost;
                            return (a1 < b1) ? -1 : (a1 > b1 ? 1 : 0);
                        } else if ('days' === self.activeTariffSort()) {
                            var a1 = left.parent.minDays, b1 = right.parent.minDays;
                            return (a1 < b1) ? -1 : (a1 > b1 ? 1 : 0);
                        } else if ('work' === self.activeTariffSort()) {
                            var a1 = left.schedules ? left.schedules.length : 0,
                                b1 = right.schedules ? right.schedules.length : 0;
                            return (a1 > b1) ? -1 : (a1 < b1 ? 1 : 0);
                        }

                        return 0;
                    }
                );
            } else {
                res.sort(
                    function (left, right) {
                        if ('cost' === self.activeTariffSort()) {
                            return left.cost < right.cost ? -1 : (left.cost > right.cost ? 1 : 0);
                        }

                        return 0;
                    }
                );
            }

            self.totalPages(Math.floor(res.length / 30));
            self.pageNum(0);
            self.paginatedPoints(res.slice(0, 30));

            return res;
        }, this
    );

    self.pageNum = ko.observable(0);
    self.totalPages = ko.observable(0);
    self.paginatedPoints = ko.observableArray([]);

    /**
     */
    self.hasPrevPage = ko.computed(
        function () {
            return (this.pageNum() > 0);
        }, this
    );

    /**
     */
    self.hasNextPage = ko.computed(
        function () {
            return (this.pageNum() < this.totalPages());
        }, this
    );

    /**
     */
    self.nextPage = function () {
        if (this.hasNextPage()) {
            var np = this.pageNum() + 1;
            this.paginatedPoints(
                this.filteredPoints().slice(
                    np * 30,
                    (np + 1) * 30
                )
            );
            this.pageNum(np);
        }
    };

    /**
     */
    self.prevPage = function () {
        if (this.hasPrevPage()) {
            var np = this.pageNum() - 1;
            this.paginatedPoints(
                this.filteredPoints().slice(
                    np * 30,
                    (this.pageNum() * 30)
                )
            );
            this.pageNum(np);
        }
    };

    /**
     */
    self.deliveryCost = ko.computed(
        function () {
            if (!self.selectedTariff()) {
                return null;
            }

            var cost = self.selectedTariff()['cost'];
            return self.formatPrice(cost);
        }, this, {pure: true}
    );

    /**
     */
    self.isMapInit = false;
    self.map = null;
    self.pointObjectManager = null;
    self.isMapOpened = false;
    self.openMap = function () {
        if (true === self.isMapOpened) {
            return;
        }

        if (!self.activeTariffType() || 'TODOOR' === self.activeTariffType()) {
            return;
        }

        if (!self.address().latitude && self.address().longitude) {
            console.log('GEO данные неполные: ', self.address());
            return;
        }

        ymaps.ready(function () {
            self.isMapOpened = true;

            if (null === self.map) {
                self.map = new ymaps.Map(
                    'points-map-wrap',
                    {
                        center: [self.address().latitude, self.address().longitude],
                        zoom: 16,
                        controls: []
                    }, {
                        searchControlProvider: 'yandex#search'
                    }
                );

                self.map.controls.add(
                    new ymaps.control.ZoomControl(
                        {
                            options: {
                                size: "small",
                                position: {
                                    left: 'auto',
                                    right: 5,
                                    top: 'auto',
                                    bottom: 25
                                }
                            }
                        }
                    )
                );

                self.map.balloon.events.add(
                    'close', function () {
                        self.activePoint(null);
                    }
                );
            }

            if (self.pointObjectManager === null) {
                self.pointObjectManager = new ymaps.ObjectManager({clusterize: true});
            }

            self.addPointsToMap();

            if (self.activePoint()) {
                self.map.setCenter([self.activePoint().location.latitude, self.activePoint().location.longitude]);
                self.map.setZoom(18);
            }

            self.map.container.fitToViewport();
            self.isMapInit = true;
        });
    };
    self.closeMap = function () {
        self.isMapOpened = false;
        self.map = null;
        self.pointObjectManager = null;
    };
    /**
     * Добавляем местоположение клиента
     */
    self.createOwnPoint = function () {
        if (self.map !== null && self.pointObjectManager !== null) {
            self.pointObjectManager.add(
                {
                    type: 'Feature',
                    id: 'myself',
                    geometry: {
                        type: 'Point',
                        coordinates: [self.address().latitude, self.address().longitude]
                    },
                    properties: {
                        hintContent: 'Вы находитесь здесь!'
                    },
                    options: {
                        preset: 'islands#governmentCircleIcon',
                        iconColor: '#ff0000'
                    }
                }
            );
        }
    };
    self.addPointsToMap = function () {
        if (self.map !== null) {
            if (self.pointObjectManager === null) {
                self.pointObjectManager = new ymaps.ObjectManager({clusterize: true});
            } else {
                self.map.geoObjects.removeAll();
                self.pointObjectManager.removeAll();
            }
        }

        self.createOwnPoint();

        var marks = [];

        self.filteredPoints().forEach(
            function (point) {
                var latitude = point.location.latitude,
                    longitude = point.location.longitude;
                var balloonContent = '<ul>';
                balloonContent += '<li>' + self.formatAddress(point.address, point.parent) + '</li>';
                balloonContent += '<li>' + point.parent.cost + ' руб.</li>';
                if ('' !== point.distance) {
                    balloonContent += '<li>От Вас ' + point.distance + ' км</li>';
                }

                balloonContent += '<li>' + point.parent.name + ' &bull; ' + self.formatDeliveryDays(point.parent) + '</li>';
                balloonContent += '</ul>';
                balloonContent = balloonContent + '<div><a href="#" class="btn-cluster-item" data-tariff="' + self.activeTariffType() + '" data-point="' + point.key + '">Подробнее</a></div>';
                balloonContent = '<div class="balloon-content-body">' + balloonContent + '</div>';

                marks.push(
                    {
                        type: 'Feature',
                        id: point['key'],
                        point: point,
                        tariff: point.parent,
                        geometry: {
                            type: 'Point',
                            coordinates: [latitude, longitude]
                        },
                        properties: {
                            clusterCaption: '<span class="cluster-caption">' + point.parent.name + '</span>',
                            balloonContent: balloonContent
                        },
                        options: {
                            hideIconOnBalloonOpen: false
                        }
                    }
                );
            }
        );

        self.pointObjectManager.add(marks);
        self.map.geoObjects.add(self.pointObjectManager);

        if (false === self.isMapInit) {
            self.pointObjectManager.objects.events.add(
                'mouseenter', function (e, el) {
                    if ('myself' !== e.get('objectId')) {
                        self.pointObjectManager.objects.setObjectOptions(
                            e.get('objectId'), {
                                preset: 'islands#redDotIcon'
                            }
                        );
                    }
                }
            );

            self.pointObjectManager.objects.events.add(
                'mouseleave', function (e, el) {
                    if ('myself' !== e.get('objectId')) {
                        self.pointObjectManager.objects.setObjectOptions(
                            e.get('objectId'), {
                                preset: 'islands#blueIcon'
                            }
                        );
                    }
                }
            );

            self.pointObjectManager.objects.events.add(
                'mouseenter', function (e, el) {
                    var objectId = e.get('objectId'),
                        object = self.pointObjectManager.objects.getById(objectId);
                    if (object.point) {
                        self.setHoverPoint(0, object.point);
                    }
                }
            );

            self.pointObjectManager.objects.events.add(
                'click', function (e, el) {
                    var objectId = e.get('objectId'),
                        object = self.pointObjectManager.objects.getById(objectId);
                    if (object.point) {
                        self.selectMapPoint(0, object.point);
                    } else {
                    }
                }
            );
        }

        self.map.setBounds(self.map.geoObjects.getBounds(), {checkZoomRange: false});
    };
    /** Выделяем объект на карте, при клике в левом меню */
    self.selectMapPoint = function (index, element) {
        if (self.map !== null && self.pointObjectManager !== null) {
            self.setHoverPoint(index, element);
            setTimeout(
                function () {
                    self.map.setCenter([element.location.latitude, element.location.longitude]);
                    self.map.setZoom(18);
                    self.map.container.fitToViewport();
                }, 80
            )
        }

        self.activePoint(element);
    };
    /** Подсвечиваем нужную точку **/
    self.setHoverPoint = function (index, element) {
        if (self.map !== null && self.pointObjectManager !== null) {
            var objectId = element['key'];
            if ('myself' !== objectId) {
                self.pointObjectManager.objects.setObjectOptions(
                    objectId, {
                        preset: 'islands#redDotIcon'
                    }
                );
            }
        }
    };

    /**
     * @param data
     */
    self.setAddress = function (data) {
        var r = self.isKladrRegion();
        self.address(data);
        if (self.address().kladr) {
            self.isKladrRegion(!String(self.address().kladr).match(/^(50|77)/));
        }

        if ((r !== self.isKladrRegion()) && (-1 === self.activeTariffFilters.indexOf('pf-gt-3'))) {
            self.toggleTariffFilter('pf-gt-3');
        } else {
            self.getTariffsFromService(data);
        }
    };

    /**
     * @param data
     */
    self.getTariffsFromService = function (data) {
        data.city = data.cityName;
        data.sum = 2500;

        ko.utils.arrayForEach(
            this.priceFilters(), function (t) {
                if (self.activeTariffFilters.indexOf(t.name) != -1) {
                    data.sum = t.sum;
                }
            }
        );

        $.ajax(
            {
                url: window.siBaseUrl,
                data: data,
                jsonp: "jsoncallback",
                dataType: 'jsonp',
                error: function (error) {
                    console.error(error);
                },
                success: function (tariffs) {
                    self.setTariffs(tariffs);
                    if (window['siActiveTariffType']) {
                        self.setActiveTariffType(self.getTariffsMapByType(window['siActiveTariffType']));
                        window['siActiveTariffType'] = null;
                    }
                }
            }
        );
    };

    /**
     */
    self.resetAll = function () {
        self.tariffsCount(0);
        self.activeTariffType(false);
        self.selectedTariff(null);
        self.activePoint(null);
        self.togglePointsListType('map');
        self.activeTariffSort('address');
    };

    /**
     * @param tariffs
     */
    self.setTariffs = function (tariffs) {
        self.resetAll();
        self.tariffs.removeAll();
        var tariffMap = {},
            tmpTariff = [
                {
                    'key': 'TODOOR',
                    'items': [],
                    'points': [],
                    'count': 0,
                    'name': "Курьером",
                    'minCost': null,
                    'minDays': null,
                    'maxDays': null
                },
                {
                    'key': "PICKUP",
                    'items': [],
                    'points': [],
                    'count': 0,
                    'name': "Пункты выдачи",
                    'minCost': null,
                    'minDays': null,
                    'maxDays': null
                },
                {
                    'key': "POST",
                    'items': [],
                    'points': [],
                    'count': 0,
                    'name': "Почтой",
                    'minCost': null,
                    'minDays': null,
                    'maxDays': null
                }
            ];

        for (var i in tmpTariff) {
            tariffMap[tmpTariff[i]['key']] = i;
        }

        for (var i in tariffs) {
            if (typeof tariffs[i] == 'object') {
                var typeDelivery = tariffs[i]['type'];
                if (tariffMap[typeDelivery] !== undefined) {
                    var kt = tariffMap[typeDelivery];
                    if (tariffs[i]['points'].length > 0) {
                        if (typeDelivery !== 'TODOOR') {
                            tariffs[i]['points'].forEach(
                                function (point) {
                                    point.distance = self.getDistance(point.location);
                                    point.parent = tariffs[i];
                                    tmpTariff[kt]['points'].push(point);
                                }
                            );
                        }
                    }

                    tmpTariff[kt]['items'].push(tariffs[i]);
                    tmpTariff[kt]['count'] += 1;

                    if (typeDelivery === 'TODOOR' || tariffs[i]['points'].length > 0) {
                        if (null === tmpTariff[kt]['minCost'] || tmpTariff[kt]['minCost'] > tariffs[i]['cost']) {
                            tmpTariff[kt]['minCost'] = tariffs[i]['cost'];
                        }

                        if (null === tmpTariff[kt]['minDays'] || tmpTariff[kt]['minDays'] > tariffs[i]['minDays']) {
                            tmpTariff[kt]['minDays'] = tariffs[i]['minDays'];
                        }

                        if (null === tmpTariff[kt]['maxDays'] || tmpTariff[kt]['maxDays'] < tariffs[i]['maxDays']) {
                            tmpTariff[kt]['maxDays'] = tariffs[i]['maxDays'];
                        }
                    }
                }
            }
        }

        var totalCount = 0;
        self.tariffs(tmpTariff);
        self.tariffs().forEach(
            function (el) {
                totalCount += el.count;
            }
        );
        self.tariffsCount(totalCount);
    };

    /**
     * @param point
     * @returns {number}
     */
    self.getDistance = function (point) {
        var result = 0;
        if (point.latitude && point.longitude && self.address().latitude && self.address().longitude) {
            result = self.getDistanceFromLatLonInKm(
                point.latitude,
                point.longitude,
                self.address().latitude,
                self.address().longitude
            ).toFixed(2);
        }

        return result;
    };

    /**
     * @param lat1
     * @param lon1
     * @param lat2
     * @param lon2
     * @returns {number}
     */
    self.getDistanceFromLatLonInKm = function (lat1, lon1, lat2, lon2) {
        var R = 6371; // Radius of the earth in km
        var dLat = self.deg2rad(lat2 - lat1);  // deg2rad below
        var dLon = self.deg2rad(lon2 - lon1);
        var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(self.deg2rad(lat1)) * Math.cos(self.deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in km
        return d;
    };

    /**
     * @param deg
     * @returns {number}
     */
    self.deg2rad = function (deg) {
        return deg * (Math.PI / 180)
    };

    /**
     * @param obj
     * @returns {*|boolean}
     */
    self.canReturn = function (data) {
        if (!data['restrictions']) {
            return false;
        }

        return (1 == (data['restrictions']['can_return'] || 0));
    };

    /**
     * @param price
     * @returns {string}
     */
    self.formatPrice = function (price) {
        return price.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ") + ' руб.';
    };

    /**
     * @param point
     * @returns {string}
     */
    self.formatPointPrice = function (point) {
        var price = self.formatPrice(point.parent.cost);
        var opts = [];
        if (point.hasPaymentCash && (parseInt(point.hasPaymentCash * 1) === 1)) {
            opts.push('нал');
        }

        if (point.hasPaymentCard && (parseInt(point.hasPaymentCard * 1) === 1)) {
            opts.push('безнал');
        }

        if (opts.length > 0) {
            price = price + '<span class="opts">(' + opts.join('/') + ')</span>';
        }

        return price;
    };

    /**
     */
    self.getActiveTariffMap = function () {
        return self.getTariffsMapByType(self.activeTariffType());
    };

    /** Получаем тариф по типу */
    self.getTariffsMapByType = function (type) {
        var result = null;
        self.tariffs().forEach(
            function (element, i) {
                if (element.key === type) {
                    result = element;
                }
            }
        );

        return result;
    };

    /** Устанавливаем активный тариф*/
    //Uncaught TypeError: can't access property "key", type is null
    self.setActiveTariffType = function (type) {
        if (type) {
            self.activeTariffType(type.key);
            self.selectedTariff(null);
            self.activePoint(null);
        }
        if (self.listType() === 'map') {
            self.closeMap();
            self.openMap();
        }
    };

    /**
     * @param tariff
     */
    self.selectTariff = function (tariff) {
        self.selectedTariff(tariff);
    };

    /**
     * @param tariff
     * @param point
     * @returns {boolean}
     */
    self.isCashAvailable = function (tariff, point) {
        if (point && point.hasPaymentCash) {
            if (parseInt(point.hasPaymentCash * 1) === 10) {
                return false;
            } else if (parseInt(point.hasPaymentCash * 1) === 1) {
                return true;
            }
        } else if (tariff && parseInt(tariff.isCashAvailable * 1) === 1) {
            return true;
        }

        return false;
    };

    /**
     * @param point
     */
    self.selectPoint = function (point) {
        var p = self.activePoint();
        if (p) {
            if (p.key === point.key) {
                self.activePoint(null);
            } else {
                self.activePoint(point);
            }
        } else {
            self.activePoint(point);
        }

        return false;
    };

    /**
     * @param tariff
     * @param point
     */
    self.selectPointCluster = function (tariff, point) {
        self.tariffs().forEach(
            function (trf) {
                if (tariff === trf.key) {
                    trf.points.forEach(
                        function (p) {
                            if (p.key === point) {
                                self.activePoint(p);
                            }
                        }
                    );
                }
            }
        );
    };

    /**
     */
    self.servicesPoint = ko.computed(
        function () {
            if (!self.activePoint()) {
                return null;
            }

            var result = [];
            var point = self.activePoint();

            if (point.hasPaymentCard === 1) {
                result.push('Оплата банковскими картами');
            }

            if (point.hasPaymentCash === 1) {
                result.push('Оплата наличными');
            }

            if (point.hasPaymentPrepaid === 1) {
                result.push('Предоплата');
            }

            if (point.restrictions && 1 == (point.restrictions['can_return'] || 0)) {
                result.push('Можно вернуть часть заказа');
            }

            return result.length > 0 ? result : null;
        }, this
    );

    /**
     */
    self.unSelectPoint = function () {
        self.tariffs().each(
            function (tariff, i) {
                if (tariff.key === self.activeTariffType()) {
                    self.setActiveTariffType(tariff, false);
                }
            }
        );
    };

    /**
     * @param tariff
     * @returns {string}
     */
    self.formatDeliveryDays = function (tariff) {
        var result = '';

        if (typeof tariff.minDays == 'string' || typeof tariff.minDays == 'number') {
            var minDays = parseInt(tariff.minDays);
            var maxDays = parseInt(tariff.maxDays);
            result = (minDays == maxDays ? maxDays : minDays + ' - ' + maxDays) + ' ' + self.getDaysSklonString(maxDays);
        }

        return result;
    };

    /**
     * @param tariff
     * @returns {string}
     */
    self.formatTariffMinCost = function (tariff) {
        var result = '';

        if (tariff.minCost) {
            result = 'от ' + tariff.minCost + ' руб.';
        } else {
            if ('TODOOR' === tariff.key) {
                result = (tariff.items.length <= 0)
                    ? '<span class="no-tariffs">Нет доступных тарифов</span>'
                    : 'Бесплатно';
            } else {
                result = (tariff.points.length <= 0)
                    ? '<span class="no-tariffs">Нет доступных тарифов</span>'
                    : 'Бесплатно';
            }
        }

        return result;
    };

    /**
     * @param days
     * @returns {string}
     */
    self.getDaysSklonString = function (days) {
        return days == 1 ? 'день' : days < 5 ? 'дня' : 'дней';
    };

    /**
     * @param address
     * @param parent
     * @returns {string}
     */
    self.formatAddress = function (address, parent) {
        var result = [];

        if (typeof address.street == 'string' && address.street !== '') {
            result.push(address.street);
        }

        if (typeof address.house == 'string' && address.house !== '') {
            result.push(address.house);
        }

        if (typeof address.building == 'string' && address.building !== '') {
            result.push(address.building);
        }

        if (typeof address.apartment == 'string' && address.apartment !== '') {
            result.push(address.apartment);
        }

        return result.join(', ');
    };

    /**
     * @param tariff
     * @param html
     * @returns {*}
     */
    self.getDeliveryDescription = function (tariff, html) {
        if (html === undefined) {
            html = false;
        }
        var res = deliveryDescription.getDescription(tariff.companyName, tariff.type, tariff.isCashAvailable);
        if (res) {
            if (html == true) {
                res = '<div class="point_description" >' + res + '</div>';
            } else {
                res = jQuery('<p>' + res + '</p>').text()
            }
        }

        return res;
    };

    /**
     * @param timeString
     * @returns {number}
     */
    self.formatTime = function (timeString) {
        var time = timeString.split(':'),
            d = new Date();

        d.setHours(+time[0]);
        d.setMinutes(time[1]);
        d.setSeconds(time[2]);

        var result = d.getHours();

        if (d.getMinutes() > 0) {
            result += ":" + d.getMinutes();
        }

        return result;
    };

    /**
     * @param point
     * @returns {string}
     */
    self.formatWorkDays = function (point) {
        var res = '';
        if (!point.schedules || point.schedules.length === 0) {
            return res;
        }

        var days = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
        var min = null, max = null;
        var ftime = null, ttime = null;
        point.schedules.forEach(
            function (item) {
                if (item.from.length > 0) {
                    if (null === min || parseInt(item.day) < min) {
                        min = parseInt(item.day);
                    }

                    if (null === max || parseInt(item.day) > max) {
                        max = parseInt(item.day);
                    }

                    if (null === ftime || item.from < ftime) {
                        ftime = item.from;
                    }
                }

                if (item.to.length > 0) {
                    if (null === ttime || item.to > ttime) {
                        ttime = item.to;
                    }
                }
            }
        );

        if (min && max && ftime && ttime) {
            res = days[min - 1] + ' - ' + days[max - 1] + '<br />' + self.formatTime(ftime) + ' - ' + self.formatTime(ttime);
        }

        return res;
    };

    /**
     * @param point
     * @returns {boolean}
     */
    self.showPointOnMap = function (point) {
        self.togglePointsListType('map');
        self.activePoint(point);

        if (true === self.isMapOpened) {
            self.map.setCenter([point.location.latitude, point.location.longitude]);
            self.map.setZoom(18);
        }

        return false;
    };

    /**
     * @type {[string,string,string,string,string,string,string]}
     */
    self.daysOfWeek = [
        'Понедельник',
        'Вторник',
        'Среда',
        'Четверг',
        'Пятница',
        'Суббота',
        'Воскресенье'
    ];
}

$(document).ready(
    function () {
        var TariffObject = new TariffModel();
        if (localStorage.getItem("pd_si_gt-3")) {
            TariffObject.toggleTariffFilter('gt-3');
        }

        if (typeof formatCountryResult == 'undefined') {
            function formatCountryResult(data, el) {
                el.addClass('country_select_el').addClass('c_' + data.id);
                return data.text;
            }
        }

        $('#country_tmp_' + window.siBlockName).maFlags({
            isISO: true,
            dropdownCssClass: 'country_select'
        }).on(
            'change', function () {
                $("#geo_aoguid_tmp_" + window.siBlockName).select2('val', '')
            }
        );

        var processResult = function (data, page) {
            var resultData = [];
            if ('ru' === $('#country_tmp_' + window.siBlockName).val()) {
                if (data.suggestions) {
                    for (const suggestion of data.suggestions) {
                        var c = suggestion.data;
                        let kladr = c.city_kladr_id || c.settlement_kladr_id;
                        let cityName = c.settlement_with_type || c.city_with_type;
                        let postalCode = c.postal_code;
                        if (!kladr && !postalCode) {
                            let regionKladrs = {
                                'area_part_kladr': c.area_kladr_id ? c.area_kladr_id.substring(0, 8) : '',
                                'region_part_kladr': c.region_kladr_id ? c.region_kladr_id.substring(0, 8) : ''
                            };
                            resultData.push({
                                continueInput: checkRegionTariffExists.check(regionKladrs)
                            });
                        } else {
                            resultData.push(
                                {
                                    id: c.fias_id,
                                    city: suggestion.value,
                                    cityName: cityName,
                                    kladr: kladr,
                                    index_city: postalCode,
                                    sum: 3000,
                                    value: suggestion.value,
                                    latitude: c.geo_lat,
                                    longitude: c.geo_lon
                                }
                            );
                        }
                    }
                }
            } else {
                data.forEach(
                    function (suggestion) {
                        resultData.push(
                            {
                                id: suggestion.place_id,
                                city: suggestion.city,
                                cityName: suggestion.city,
                                value: suggestion.city,
                                place_id: suggestion.place_id,
                                sum: 3000,
                                latitude: suggestion.latitude,
                                longitude: suggestion.longitude
                            }
                        );
                    }
                );
            }

            return {results: resultData};
        };

        var checkRegionTariffExists = {
            check: async function (kladrs) {
                let result = false;
                if (typeof kladrs === 'object') {
                    if (typeof siBaseUrl === 'undefined') {
                        return false;
                    }
                    result = await $.ajax({
                        type: 'GET',
                        url: siBaseUrl + '-part-kladr',
                        data: $.param(kladrs),
                        dataType: 'jsonp',
                        jsonp: 'jsoncallback'
                    })
                }

                return result;
            },
            process: async function (promise) {
                return promise.then();
            }
        };

        var provider = {
            url: function (params) {
                return ('ru' === $('#country_tmp_' + window.siBlockName).val())
                    ? 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address'
                    : "/servicedelivery/region/searchCity";
            },
            transport: function (params, success, failure) {
                if ('ru' === $('#country_tmp_' + window.siBlockName).val()) {
                    params['headers'] = {
                        "Authorization": "Token " + window.siDadataToken,
                        "Content-Type": "application/json"
                    };
                    params['method'] = 'POST';
                    var $request = $.ajax(params);
                    $request.then(success);
                    $request.fail(failure);
                    return $request;
                } else {
                    params['method'] = 'GET';
                    params['dataType'] = 'jsonp';
                    var $request = $.ajax(params);
                    $request.then(success);
                    $request.fail(failure);
                    return $request;
                }
            },
            quietMillis: 500,
            data: function (term, page) {
                return ('ru' === $('#country_tmp_' + window.siBlockName).val())
                    ? JSON.stringify({query: term, count: 1})
                    : {q: term, country: $('#country_tmp_' + window.siBlockName).val()};
            },
            results: function (data, page) {
                return processResult(data, page);
            }
        };

        var initSelect2 = function () {
            $("#geo_aoguid_tmp_" + window.siBlockName).select2(
                {
                    // placeholder: window.siPlaceholder,
                    minimumInputLength: 2,
                    ajax: provider,
                    formatResult: function (city) {
                        if (city.hasOwnProperty('continueInput')) {
                            city.continueInput.then(function (result) {
                                if (result) {
                                    let text = result ? siContinueText : siEmptyText;
                                    let html = '<li class="select2-no-results">' + text + '</li>';
                                    $('.select2-result-label').replaceWith(html);
                                }
                            });
                            return;
                        }

                        return city.value;
                    },
                    formatSelection: function (city) {
                        return city.city
                    },
                    dropdownCssClass: "bigdrop",
                    escapeMarkup: function (m) {
                        return m;
                    },
                    initSelection: function (element, callback) {
                        var url = ('ru' === $('#country_tmp_' + window.siBlockName).val())
                            ? 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address'
                            : "/servicedelivery/region/searchCity";
                        var params = {};
                        if ('ru' === $('#country_tmp_' + window.siBlockName).val()) {
                            params['headers'] = {
                                "Authorization": "Token " + window.siDadataToken,
                                "Content-Type": "application/json"
                            };
                            params['data'] = JSON.stringify(
                                {
                                    query: window['siCityName'] || $('.region-shipping-info .region-select .geo-address-link:first').text(),
                                    count: 1
                                }
                            );
                            params['method'] = 'POST';
                        } else {
                            params['method'] = 'GET';
                            params['dataType'] = 'jsonp';
                            params['data'] = {
                                q: window['siCityName'] || $('.region-shipping-info .region-select .geo-address-link:first').text(),
                                country: $('#country_tmp_' + window.siBlockName).val()
                            };
                        }

                        $.ajax(url, params).done(
                            function (data) {
                                try {
                                    var res = processResult(data);
                                    res = res.results[0];
                                    callback(res);
                                    TariffObject.setAddress(res);
                                    if (window['siCityName']) {
                                        window['siCityName'] = null;
                                    }
                                } catch (e) {
                                }
                            }
                        );
                    }
                }
            ).change(
                function () {
                    var data = jQuery("#geo_aoguid_tmp_" + window.siBlockName).select2("data");
                    TariffObject.setAddress(data);
                }
            );
        };

        var activePickupTab = function () {
            let firstTab = $(".shipping .tab_content:first");
            let lastTab = $(".shipping .tab_content:last");
            if (typeof firstTab !== 'undefined' && typeof lastTab !== 'undefined') {
                firstTab.hide();
                lastTab.show();
                window.siActiveTariffType = 'PICKUP';
            }

            initSelect2();
        };

        activePickupTab();

        $(document).on(
            'PdReinitSiBlockName', function () {
                $("#geo_aoguid_tmp_" + window.siBlockName).select2('destroy');
                initSelect2();
            }
        );

        $(document).on(
            'click', '.btn-cluster-item', function () {
                TariffObject.selectPointCluster($(this).data('tariff'), $(this).data('point'));
                return false;
            }
        );

        $(document).on(
            'kosi:setActiveTariffType', function (event, tariffType) {
                if (tariffType) {
                    TariffObject.setActiveTariffType(TariffObject.getTariffsMapByType(tariffType));
                }

                return true;
            }
        );

        ko.applyBindings(TariffObject);
    }
);
